<template>
  <v-container>
    <div v-if="!customerEmail">
      <v-row class="email-form">
        <v-col col="12">
          <v-text-field label="Enter customer email address " color="primary" type="text" v-model="customerEmailInput"
            prepend-icon="mdi-email" />
        </v-col>
      </v-row>
      <v-row>
        <v-col col="12">
          <v-btn color="primary" @click="submitEmailAndFetchBusinesses" type="button" class="btn btn-primary"
            style="margin: 0 auto; display: block">
            Submit
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <div class="app-loader" v-if="customerBusinessListWaiting">
      <v-progress-circular class="mx-auto" :size="70" :width="7" indeterminate></v-progress-circular>
    </div>
    <v-row v-else-if="customerBusinessListError">
      <v-alert class="mx-auto" style="width: auto" type="error">
        Could not fetch the business list. {{ customerBusinessListError }}
      </v-alert>
    </v-row>

    <div class="actions-controls" v-show="customerBusinessList.length" v-else>
      <div class="business-section">
        <v-row align="center" justify="center">
          <v-col cols="12">
            <v-card>
              <v-card-title>
                All Customer Businesses
                <v-spacer></v-spacer>
              </v-card-title>
              <div class="business-section">
                <user-businesses :businesses="customerBusinessList"></user-businesses>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import userBusinesses from "../../components/user/user-businesses.vue";

export default {
  components: {
    userBusinesses,
  },
  data() {
    return {
      customerEmailInput: "",
    };
  },
  computed: {
    ...mapGetters({
      activeAccount: "partner/active",
      customerBusinessListWaiting: "customer/customerBusinessListWaiting",
      customerBusinessListError: "customer/customerBusinessListError",
      customerBusinessList: "customer/customerBusinessList",
      customerEmail: "customer/customerEmail",
    }),
  },
  methods: {
    ...mapActions({
      fetchBusinessesFromEmail: "customer/fetchBusinessesFromEmail",
    }),
    async submitEmailAndFetchBusinesses() {
      this.emailSubmitted = true;
      await this.fetchBusinessesFromEmail(this.customerEmailInput);
    },
  },
};
</script>

<style>
.home {
  min-height: 100%;
}

.actions {
  display: flex;
  justify-content: flex-end;
}

.centered-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}

.app-loader {
  height: 50vh;
}

</style>
